import React, { useState } from "react";
import { Menu } from "antd";

const PresenceSiege = ({ setSelectedClient, clients, setIsNoAccessDisplayed }) => {
  const [current, setCurrent] = useState("accounting");
  const getStyle = menuItemKey =>
    current === menuItemKey ? "font-bold pb-6 uppercase tracking-wide" : "pb-6 uppercase tracking-wide";

  return (
    <div className="mb-4">
      <Menu
        onClick={e => {
          const getClient = clients.find(item => item.client_label === e.key);

          if (getClient) {
            setIsNoAccessDisplayed(false);
            setSelectedClient(getClient.client_id);
          } else setIsNoAccessDisplayed(true);
          setCurrent(e.key);
        }}
        selectedKeys={[current]}
        mode="horizontal"
      >
        <Menu.Item key="COMPTA">
          <div className={getStyle("accounting")}>Compta</div>
        </Menu.Item>
        <Menu.Item key="RH">
          <div className={getStyle("humanResource")}>RH</div>
        </Menu.Item>
        <Menu.Item key="COMMUNICATION">
          <div className={getStyle("communication")}>Communication</div>
        </Menu.Item>
        <Menu.Item key="INFORMATIQUE">
          <div className={getStyle("it")}>Informatique</div>
        </Menu.Item>
        <Menu.Item key="AUTO">
          <div className={getStyle("auto")}>Auto</div>
        </Menu.Item>
      </Menu>
    </div>
  );
};

export default PresenceSiege;



// WEBPACK FOOTER //
// src/modules/presence/presence/PresenceSiege.js